<template>
    <!-- 费率折扣设置 -->
    <div class="merchantList">
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item>
                    <el-button
                        size="medium"
                        type="primary"
                        icon="el-icon-search"
                        style="font-size: 12px;"
                        @click="onSearch(searchForm)"
                    >查询</el-button>
					<el-button
					    size="medium"
					    type="primary"
					    icon="el-icon-search"
					    style="font-size: 12px;"
					    @click="addDiscount(searchForm)"
					>添加折扣设置</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <el-table
                :data="marchantList"
                size="mini"
                border
                style="width: 100%"
                v-loading="loading"
            >
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed
                    type="index"
                    label="ID"
                    min-width="80"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="discount"
                    label="费率折扣"
                    min-width="120"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="expiry_time_text"
                    label="过期时间"
                    min-width="120"
                >
                </el-table-column>
                <!-- 操作 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed="right"
                    label="操作"
                    min-width="150"
                >
                    <template slot-scope="scope">
                      <el-button @click="handleInfo(scope.row)" type="text" size="small">修改</el-button>
					  <el-popconfirm
					      title="是否确认删除此消息？"
					      @onConfirm="deletes(scope.row)"
					  >
					      <el-button slot="reference" type="text" size="small">删除</el-button>
					  </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10,20,50,100]"
                :current-page="currentPage"
                :page-size="pageSize"
                :total="total"
                layout="total, sizes, prev, pager, next, jumper"
            ></el-pagination>
        </el-card>
		<!-- 添加折扣设置 -->
		<el-dialog title="添加折扣设置" :visible.sync="dialogFormVisible">
		  <el-form :model="discount" label-width="120px"  label-position="right">
		    <el-form-item label="折扣">
					<el-input v-model.number="discount.discount" oninput="value=value.replace(/[^\d]/g,'')" maxlength="4" style="width: 200px;" size  clearable placeholder="请输入折扣"></el-input>
		    </el-form-item>
		    <el-form-item label="过期时间">
					<el-date-picker
					      v-model="discount.expiry_time"
					      type="date"
						  size
						  clearable
						  style="width: 200px;"
						  format="yyyy 年 MM 月 dd 日"
						  value-format="yyyy-MM-dd"
						  :picker-options="pickerOptions0"
					      placeholder="请选择日期">
					    </el-date-picker>
		    </el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="dialogFormVisible = false">取 消</el-button>
		    <el-button type="primary" @click="addSave()">确 定</el-button>
		  </div>
		</el-dialog>
    </div>
</template>

<script>
export default {
    name: "merchant-net",
    data() {
        return {
			dialogFormVisible:false,
			discount:{
				id:"",
				discount:0,
				expiry_time:'',
			},
            searchForm: {
                
            },
            rangeDate: '',
            id:'',
            marchantList: [],
            currentPage: 1, //当前页码
            pageSize: 10, //条数
            total: 0,  //总数
            loading: true,pickerOptions0: { 
			 disabledDate(time) {
				return time.getTime() < Date.now() - 8.64e7;//只能选择今天和今天以后的
			 }
  	},
        }
    },
    created() {

    },
    mounted() {
        this.getData({
            page: 1,
            limit: 10
        })
    },
    methods: {
		addDiscount(){
			this.dialogFormVisible = true;
		},
		addSave(){
			let url = 'terminal/rateDiscountAdd';
			console.log(this.discount)
			if(this.discount.id != ""){
				url = 'terminal/rateDiscountEdit'
			}
			this.$api.post(url, this.discount, res => {
				if(res.code == 0){
					this.dialogFormVisible = false;
					this.$message({type: 'success',message: '操作成功!'});
					this.getData({
					    page: this.currentPage,
					    limit: this.pageSize
					})
					this.discount = {id:""};
				}else{
					this.$message({type: 'error',message: res.msg});
				}
			})
		},
        onSearch(searchFrom) {
            this.currentPage = 1;
            searchFrom.page = 1;
            this.getData(searchFrom);
        },
        getData(params) { //获取数据
            this.loading = true;
            this.$api.post("terminal/rateDiscountList", params, res => {
                let data = res.data;
                this.total = data.count; //总数
                this.marchantList = res.data.data;
                //渲染结束后取消加载
                this.loading = false;
            })
        },
        handleCurrentChange(page) { //当前选中页
            this.currentPage = page;
            this.searchForm.page = page;
            this.searchForm.limit = this.pageSize;
            this.getData(this.searchForm);
        },
        handleSizeChange(limit) { //条数
            this.currentPage = 1;
            this.pageSize = limit;
            this.searchForm.page = 1;
            this.searchForm.limit = limit;
            this.getData(this.searchForm);
        },
        handleInfo(row) { //修改
			this.discount = row;
			this.dialogFormVisible = true;
        },
		deletes(row) { //删除
			this.$api.post('terminal/rateDiscountDel', { id: row.id }, res => {
				if (res.code == 0) {
					this.$message({type: 'success',message: '删除成功!'});
					this.getData({
					    page: this.currentPage,
					    limit: this.pageSize
					})
				} else {
					this.$message.error(res.msg);
				}
			})
		},
        pickerChange(DateArr) { //时间选择器
            this.searchForm.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
            this.searchForm.end_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
        },
    }
}
</script>

<style scoped lang="scss">
.merchantList {
    .el-input__inner {
        font-size: 12px;
    }
    .el-form-item {
        margin-bottom: 5px;
    }
}
</style>